import { render, staticRenderFns } from "./ImsPrintTicket.vue?vue&type=template&id=33c123a6&"
import script from "./ImsPrintTicket.vue?vue&type=script&lang=js&"
export * from "./ImsPrintTicket.vue?vue&type=script&lang=js&"
import style0 from "./ImsPrintTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports